import * as types from './mutation-types'
let defaultObject = () => ({
  data: {
    name: ''
  }
})

export default {
  [types.SET_HOTEL_CATEGORY] (state, payload) {
    if (payload === null) {
      payload = defaultObject()
    }
    state.category = payload
  },
  [types.SET_HOTEL_CATEGORIES] (state, payload) {
    state.categories = payload.data
    state.pagination = payload.meta.pagination
  }
}
